import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AxiosObservable } from 'axios-observable/dist/axios-observable.interface';
import { FuncionalidadeAPI } from '@/api/funcionalidades.api';
import { Funcionalidade } from '@/models/funcionalidade';

const api = new FuncionalidadeAPI();

const list = (params: any): Observable<any> => {
  return api.list(params);
}

const show = (id: number): AxiosObservable<Funcionalidade> => {
  return api.show(id);
}

const create = (funcionalidade: any): AxiosObservable<Funcionalidade> => {
  return api.create({ functionality: { ...funcionalidade } })
}

const update = (id: number, funcionalidade: any): AxiosObservable<Funcionalidade> => {
  return api.update(id, { functionality: { ...funcionalidade } })
}

export default {
  list,
  show,
  create,
  update
}
